import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  TextField,
  BooleanField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Схема статуса партнёра.
 *
 * Описывает допустимые статусы взаимодействия с партнёром
 * (активные, тухляки, интересуются сотрудничеством и т.д.).
 */
export const PartnerStatusSchema = Type.Object({
  ...SystemFields,

  code: StringField({
    title: 'Код статуса',
    minLength: 1,
    maxLength: 100,
    unique: true,
    description: 'Уникальный символьный код статуса (например, ACTIVE).',
  }),

  name: StringField({
    title: 'Название статуса',
    minLength: 1,
    maxLength: 255,
    description: 'Человекочитаемое название статуса партнёра.',
  }),

  color: StringField({
    title: 'Цвет',
    maxLength: 7,
    default: '#3b82f6',
    description: 'Hex-код цвета для отображения в интерфейсе',
  }),

  description: TextField({
    title: 'Описание статуса',
    nullable: true,
    description: 'Дополнительное описание статуса для администраторов.',
  }),

  is_default: BooleanField({
    title: 'Статус по умолчанию',
    default: false,
    description: 'Статус, назначаемый новым партнёрам автоматически.',
  }),

  is_active: BooleanField({
    title: 'Статус активен',
    default: true,
    description: 'Флаг, определяющий доступность статуса для назначения.',
  }),
});

export type PartnerStatus = Static<typeof PartnerStatusSchema>;

export default defineSchema({
  moduleName,
  tableName: 'partner_status',
  schema: PartnerStatusSchema,
  additionalIndexes: [{ columns: ['code'], unique: true }, 'is_active'],
  dependencies: [],
});
